
import { mapSixActivitiesDTOToSixActivities } from "@/store/mappers/mapSixDetail";
import { createAppAsyncThunk } from "@/store/thunks/createAppAsyncThunk";

export const fetchActivity = createAppAsyncThunk(
  "sixDetail/fetchActivity",
  async(sixId: string, { extra }) => {
    const activityDTO = await extra.sixDetailService.fetchActivity(sixId);
    return mapSixActivitiesDTOToSixActivities(activityDTO);
  }
);
